import { Flex, Icon, Link, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { HighlightedIcon } from '../../HighlightedIcon'

interface EligibilityRequirementRowProps {
  title: string
  icon: ReactElement
  onClick: () => void
}

export const EligibilityRequirementRow = ({ title, icon, onClick }: EligibilityRequirementRowProps): ReactElement => (
  <>
    <Flex justifyContent="space-between" alignItems="center">
      <Flex alignItems="center">
        <HighlightedIcon>{icon}</HighlightedIcon>
        <Link onClick={onClick}>
          <Text colorVariant="secondary" variant="bodySM">
            {title}
          </Text>
        </Link>
      </Flex>
      <Icon icon="chevronRight" />
    </Flex>
    <Space size="s12" />
  </>
)
